// logger.js
import axios from 'axios'
import packageJs from '~/package.json'

const clientInfo = {
  client: 'dupe.com',
  url: process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL || 'localhost:3000',
  clientVersion: packageJs.version,
  clientEnv: process.env.NEXT_PUBLIC_VERCEL_ENV || 'development',
}

const DATADOG_API_ENDPOINT = '/api/logger'
export class Logger {
  static async logToDatadog(
    logLevel: string,
    message: string,
    params?: Record<string, any>
  ) {
    try {
      const logData = {
        level: logLevel,
        message,
        ...clientInfo,
        ...(params || {}),
      }

      if (logLevel === 'debug') {
        // noop
        return
      }

      const isProd = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'

      const host = isProd
        ? 'dupe.com'
        : process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL || 'localhost:3000'
      const fullUrl =
        host === 'localhost:3000'
          ? `http://${host}${DATADOG_API_ENDPOINT}`
          : `https://${host}${DATADOG_API_ENDPOINT}`

      await axios.post(`${fullUrl}`, logData)
    } catch (error) {
      // Error logging to Datadog
      // noop
    }
  }

  static debug(message: string, params?: Record<string, any>) {
    Logger.log('debug', message, params)
  }

  static info(message: string, params?: Record<string, any>) {
    Logger.log('info', message, params)
  }

  static warn(message: string, params?: Record<string, any>) {
    Logger.log('warn', message, params)
  }

  static error(message: string, params?: Record<string, any>) {
    Logger.log('error', message, params)
  }

  private static log(
    level: 'debug' | 'info' | 'warn' | 'error',
    message: string,
    params?: Record<string, any>
  ) {
    // Skip logging in tests
    if (process.env.NODE_ENV === 'test' && level === 'debug') return

    const isProd = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
    if (
      process.env.NODE_ENV === 'development' ||
      (!isProd && level === 'debug')
    ) {
      if (level === 'debug') {
        params
          ? console[level](`%c [DEBUG] ${message}`, 'color: #00f', params)
          : console[level](`%c [DEBUG] ${message}`, 'color: #00f')
        return
      } else {
        params ? console[level](message, params) : console[level](message)
        return
      }
    }

    Logger.logToDatadog(level, message, params)
  }
}

export default Logger
